import { render, staticRenderFns } from "./Yapo.vue?vue&type=template&id=46b3362a&"
import script from "./Yapo.vue?vue&type=script&lang=js&"
export * from "./Yapo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports